var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_707",
    "data-name": "Rectangle 707",
    width: 128,
    height: 128,
    transform: "translate(1527 6782)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customers",
    transform: "translate(-1527 -6782)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customers-2",
    "data-name": "customers",
    transform: "translate(1523.067 6779.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14146",
    "data-name": "Path 14146",
    d: "M8.855,100.667A65.913,65.913,0,0,1,14.524,27.9a59.49,59.49,0,0,1,5.328-6.053,66.071,66.071,0,0,1,93.437,0,62.086,62.086,0,0,1,7.076,8.4h.043a66,66,0,0,1,3.879,70.418Z",
    transform: "translate(1.631 1.616)",
    fill: "#82c8ec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14147",
    "data-name": "Path 14147",
    d: "M57.4,18.341a179.946,179.946,0,0,1-39.552-4.4,63.087,63.087,0,0,1-14.3-5.048.492.492,0,1,1,.437-.882,62.1,62.1,0,0,0,14.079,4.969,178.951,178.951,0,0,0,41.269,4.37h.008A192.267,192.267,0,0,0,93.406,14.5a98.721,98.721,0,0,0,16.12-4.153.492.492,0,1,1,.325.929,99.7,99.7,0,0,1-16.279,4.194A193.251,193.251,0,0,1,59.344,18.33C58.7,18.337,58.051,18.341,57.4,18.341Z",
    transform: "translate(12.337 21.052)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14148",
    "data-name": "Path 14148",
    d: "M75.516,59.166a.492.492,0,0,1-.491-.457,108.369,108.369,0,0,0-3.9-22.023l-.255-.892c-2.917-9.828-7.116-18.068-12.143-23.829C53.6,6.09,47.745,2.985,41.8,2.985c-5.849,0-11.625,3.009-16.7,8.7-4.986,5.589-9.174,13.588-12.109,23.133l0,.011c-.06.18-.11.36-.163.552s-.108.39-.175.59A108.6,108.6,0,0,0,8.573,58.708a.492.492,0,1,1-.982-.069A109.592,109.592,0,0,1,11.7,35.688l.006-.018c.06-.18.11-.36.163-.552s.109-.392.176-.594c2.977-9.678,7.235-17.8,12.314-23.494a29.925,29.925,0,0,1,8.234-6.655,19.022,19.022,0,0,1,18.55.077,30.222,30.222,0,0,1,8.322,6.864c5.119,5.867,9.388,14.235,12.345,24.2v0l.256.9a109.353,109.353,0,0,1,3.939,22.223.492.492,0,0,1-.456.526Z",
    transform: "translate(26.402 1.623)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    "data-name": "Line 1",
    d: "M9.8.485h-9.8A.492.492,0,0,1-.5-.008.492.492,0,0,1-.008-.5H9.8a.492.492,0,0,1,.492.492A.492.492,0,0,1,9.8.485Z",
    transform: "translate(44.126 70.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M13.42.485H-.008A.492.492,0,0,1-.5-.008.492.492,0,0,1-.008-.5H13.42a.492.492,0,0,1,.492.492A.492.492,0,0,1,13.42.485Z",
    transform: "translate(120.853 70.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14149",
    "data-name": "Path 14149",
    d: "M29.4,18.485H19.342a.492.492,0,0,1,0-.985H29.4a.492.492,0,1,1,0,.985Z",
    transform: "translate(63.139 52.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M13.42.485H-.008A.492.492,0,0,1-.5-.008.492.492,0,0,1-.008-.5H13.42a.492.492,0,0,1,.492.492A.492.492,0,0,1,13.42.485Z",
    transform: "translate(2.139 70.194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14150",
    "data-name": "Path 14150",
    d: "M33.34,30.4A14.919,14.919,0,1,1,3.5,30.4a1.449,1.449,0,0,1,.043-.426A14.885,14.885,0,0,1,33.3,29.808,2.814,2.814,0,0,1,33.34,30.4Z",
    transform: "translate(11.418 44.044)",
    fill: "#ffd9aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14151",
    "data-name": "Path 14151",
    d: "M33.263,29.808l-.725-.085a31.036,31.036,0,0,1-12.021-3.2,37.647,37.647,0,0,1-16.411,3.5l-.6-.043a14.885,14.885,0,0,1,29.753-.171Z",
    transform: "translate(11.452 44.044)",
    fill: "#57565d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14152",
    "data-name": "Path 14152",
    d: "M6.41,28.768A8.64,8.64,0,0,1,3,21.947a8.525,8.525,0,0,1,16.752-2.131Z",
    transform: "translate(9.788 37.582)",
    fill: "#57565d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14153",
    "data-name": "Path 14153",
    d: "M51.341,30.413a14.919,14.919,0,1,1-29.838,0,5.621,5.621,0,0,1,.085-1.194,14.889,14.889,0,0,1,29.668-.213C51.3,29.475,51.341,29.944,51.341,30.413Z",
    transform: "translate(70.144 44.036)",
    fill: "#ffd9aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14154",
    "data-name": "Path 14154",
    d: "M51.188,29.006c-1.151-.426-2.046-.725-2.046-.725L36.951,24.828a8.525,8.525,0,0,0-5.541.3l-7.843,3.154-2.046.938a14.889,14.889,0,0,1,29.668-.213Z",
    transform: "translate(70.212 44.036)",
    fill: "#57565d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14155",
    "data-name": "Path 14155",
    d: "M20.5,54.338H67.389V45.813A21.313,21.313,0,0,0,46.076,24.5H33.288A21.236,21.236,0,0,0,25.7,25.907Z",
    transform: "translate(66.884 73.393)",
    fill: "#55bb8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14156",
    "data-name": "Path 14156",
    d: "M42.188,25.907A21.236,21.236,0,0,0,34.6,24.5H21.813A21.313,21.313,0,0,0,.5,45.813v8.525H47.389Z",
    transform: "translate(1.631 73.393)",
    fill: "#fbde53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14157",
    "data-name": "Path 14157",
    d: "M36.288,20.5V35.419a6.394,6.394,0,0,1-6.394,6.394h0A6.394,6.394,0,0,1,23.5,35.419V20.5Z",
    transform: "translate(76.671 60.342)",
    fill: "#ffd9aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14158",
    "data-name": "Path 14158",
    d: "M43.6,22.5h0A21.313,21.313,0,0,1,64.914,43.813v17.05H9.5V43.813A21.313,21.313,0,0,1,30.813,22.5h0",
    transform: "translate(30.995 66.868)",
    fill: "#ed456a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14159",
    "data-name": "Path 14159",
    d: "M56.651,18.5V33.419a6.394,6.394,0,0,1-6.394,6.394h0a6.394,6.394,0,0,1-6.394-6.394V18.5ZM18.288,27.025V41.944a6.394,6.394,0,0,1-6.394,6.394h0A6.394,6.394,0,0,1,5.5,41.944V27.025Z",
    transform: "translate(17.944 53.817)",
    fill: "#ffd9aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_4",
    "data-name": "Line 4",
    d: "M-.008,47.373A.492.492,0,0,1-.5,46.881V-.008A.492.492,0,0,1-.008-.5a.492.492,0,0,1,.492.492V46.881A.492.492,0,0,1-.008,47.373Z",
    transform: "translate(68.21 4.123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14160",
    "data-name": "Path 14160",
    d: "M42.34,28.317a14.919,14.919,0,1,1-29.838,0,8.9,8.9,0,0,1,.043-1.066,14.919,14.919,0,0,1,29.71-.341C42.3,27.38,42.34,27.848,42.34,28.317Z",
    transform: "translate(40.781 37.606)",
    fill: "#ffd9aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14161",
    "data-name": "Path 14161",
    d: "M42.22,26.911l-2.046-.725L27.983,22.733a8.525,8.525,0,0,0-5.541.3L14.6,26.186,12.51,27.252a14.919,14.919,0,0,1,29.71-.341Z",
    transform: "translate(40.815 37.606)",
    fill: "#57565d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14162",
    "data-name": "Path 14162",
    d: "M128.582,101.776a68.027,68.027,0,0,0-4.808-71.147,1.959,1.959,0,0,0-.158-.2h0l-.043-.051a64.744,64.744,0,0,0-7.119-8.4,68.2,68.2,0,0,0-96.45,0,61.534,61.534,0,0,0-5.2,5.882,2.131,2.131,0,0,0-.55.661.122.122,0,0,1-.026.09,67.891,67.891,0,0,0-6.394,73.181A23.368,23.368,0,0,0,0,119.206v8.525a2.131,2.131,0,0,0,2.131,2.131H134.272a2.131,2.131,0,0,0,2.131-2.131v-8.525a23.368,23.368,0,0,0-7.822-17.43Zm-3.521-2.613a23.239,23.239,0,0,0-9.97-3.295v-6.5a2.017,2.017,0,0,0-.043-.217,16.249,16.249,0,0,0,8.376-16.833h8.649a63.458,63.458,0,0,1-7.012,26.854Zm-18.5-11.927A12.788,12.788,0,0,1,93.778,74.448a2.132,2.132,0,0,0,.8-.153l7.86-3.171a6.334,6.334,0,0,1,4.13-.217l12.2,3.466a2.088,2.088,0,0,0,.58.043v.034A12.788,12.788,0,0,1,106.565,87.236Zm4.263,3.657v4.868a4.263,4.263,0,0,1-8.525,0V90.894a15.307,15.307,0,0,0,8.525,0ZM98.04,95.958a23.158,23.158,0,0,0-4.582.887,23.419,23.419,0,0,0-16.731-9.5v-6.5a2.017,2.017,0,0,0-.043-.217,17.05,17.05,0,0,0,7.289-8.308H89.72a16.745,16.745,0,0,0-.2,2.131,16.991,16.991,0,0,0,8.568,14.7,2.017,2.017,0,0,0-.043.217v6.586ZM68.2,78.711A12.788,12.788,0,0,1,55.414,65.923a2.132,2.132,0,0,0,.8-.153l7.86-3.171a6.339,6.339,0,0,1,4.13-.217l12.2,3.466a2.1,2.1,0,0,0,.58.043v.034A12.788,12.788,0,0,1,68.2,78.711Zm4.263,3.657v4.868a4.263,4.263,0,1,1-8.525,0V82.368a15.307,15.307,0,0,0,8.525,0ZM59.677,87.343a23.419,23.419,0,0,0-16.761,9.5,23.158,23.158,0,0,0-4.552-.891c0-.068,0-.128,0-.192V89.368a2.017,2.017,0,0,0-.043-.217,16.991,16.991,0,0,0,8.568-14.7,16.742,16.742,0,0,0-.217-2.131H52.43a17.05,17.05,0,0,0,7.3,8.308,2.017,2.017,0,0,0-.055.217v6.5Zm-29.838-.107A12.762,12.762,0,0,1,17.217,76.081a41.723,41.723,0,0,0,14.749-3.086A34.983,34.983,0,0,0,42.5,75.727a12.762,12.762,0,0,1-12.66,11.509ZM34.1,90.894v4.868a4.263,4.263,0,0,1-8.525,0V90.894a16.854,16.854,0,0,0,4.263.605,16.854,16.854,0,0,0,4.263-.605ZM51.369,68.055H45.61A17.11,17.11,0,0,0,36.752,58.9a106.774,106.774,0,0,1,3.683-20.209,196.863,196.863,0,0,0,25.623,2.225v8.171A17.016,17.016,0,0,0,51.151,65.923a16.746,16.746,0,0,0,.217,2.131ZM42.2,71.371a26.053,26.053,0,0,1-9.122-2.617,2.131,2.131,0,0,0-2.229,0A33.359,33.359,0,0,1,17.315,71.84,12.762,12.762,0,0,1,42.2,71.371ZM16.624,63.792a6.345,6.345,0,1,1,10.729-6.142,16.944,16.944,0,0,0-10.729,6.142Zm78.112,5.84a12.749,12.749,0,0,1,23.726.217l-10.72-3.039a10.7,10.7,0,0,0-6.9.362Zm37.323-1.577h-9.723a17.085,17.085,0,0,0-12.57-10.333,2.072,2.072,0,0,0-1.07-.324h-1.108a2.007,2.007,0,0,0-.341.068c-.23,0-.448-.068-.682-.068a16.9,16.9,0,0,0-2.766.281,110.67,110.67,0,0,0-3.376-18.64c1.957-.281,3.917-.563,5.772-.9A103.071,103.071,0,0,0,121.156,34.4a63.428,63.428,0,0,1,10.9,33.658ZM113.411,24.977a61.76,61.76,0,0,1,5.09,5.818,101.76,101.76,0,0,1-13.048,3.146c-1.995.367-4.1.674-6.219.972A58.172,58.172,0,0,0,83.176,8.058a63.47,63.47,0,0,1,30.235,16.918ZM70.333,6.4C80.227,7.768,89.4,18.587,94.92,35.445a205.589,205.589,0,0,1-23.24,1.309c-.452,0-.9-.021-1.347-.026Zm0,34.6c.452,0,.9.026,1.347.026A209.293,209.293,0,0,0,96.169,39.6a106.24,106.24,0,0,1,3.47,19.3,17.11,17.11,0,0,0-8.845,9.156H85.035a16.744,16.744,0,0,0,.217-2.131A17.05,17.05,0,0,0,71.395,49.2a2.072,2.072,0,0,0-1.061-.324ZM80.1,61.32,69.378,58.28a10.72,10.72,0,0,0-6.9.362l-6.1,2.464a12.749,12.749,0,0,1,23.726.217ZM66.071,6.4V36.669a193.256,193.256,0,0,1-24.34-2.084C47.268,18.233,56.343,7.751,66.071,6.4ZM22.993,24.977a63.47,63.47,0,0,1,30.222-16.9A57.025,57.025,0,0,0,37.485,33.851c-2.319-.426-4.574-.9-6.688-1.415a67.775,67.775,0,0,1-11.266-3.67C20.588,27.509,21.71,26.255,22.993,24.977ZM16.85,32.223a69.105,69.105,0,0,0,12.937,4.369c2.042.5,4.22.955,6.454,1.377A111.094,111.094,0,0,0,32.6,57.692c-.315-.051-.639-.064-.959-.1a2.093,2.093,0,0,0-.038-.712,10.657,10.657,0,0,0-20.946,2.647,10.767,10.767,0,0,0,3.662,7.946c-.09.2-.179.384-.26.58H4.352A63.973,63.973,0,0,1,16.846,32.21ZM4.331,72.317h8.674a16.744,16.744,0,0,0-.217,2.131,16.991,16.991,0,0,0,8.568,14.7,2.016,2.016,0,0,0-.043.217v6.5a23.24,23.24,0,0,0-9.983,3.3,63.458,63.458,0,0,1-7-26.846Zm34.033,38.364V125.6H4.263v-6.394a19.182,19.182,0,0,1,18.287-19.092,8.453,8.453,0,0,0,14.582,0,18.909,18.909,0,0,1,3.534.507A23.257,23.257,0,0,0,38.364,110.681ZM93.778,125.6H42.626V110.681A19.182,19.182,0,0,1,60.913,91.588a8.457,8.457,0,0,0,14.578,0,19.182,19.182,0,0,1,18.287,19.092Zm38.364,0H98.04V110.681a23.257,23.257,0,0,0-2.3-10.064,18.91,18.91,0,0,1,3.534-.507,8.453,8.453,0,0,0,14.582,0,19.182,19.182,0,0,1,18.287,19.1Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomers);
export default __webpack_public_path__ + "static/media/customers.0348b7e4265050f868cfd038e9ac8b22.svg";
export { ForwardRef as ReactComponent };